/**
 * Libellés de la facturation : une donnée versionnée, jamais de texte dispersé dans les composants.
 * Le nombre maximal d'échéances du calendrier de collecte vient de la réunion du 16/10 (point 50).
 */
export const VERSION_LIBELLES = '2026-10-18';

/** Ordre d'affichage des règles : toutes les règles du contrat sont proposées, cochées ou non. */
export const ORDRE_REGLES: readonly string[] = [
  'forfait_phase',
  'repartition_quote_part',
  'frais_reels',
  'avance_heritier',
  'echeancier',
  'reglement_avoirs_notaire',
  'remise',
];

export const LIBELLES_REGLES: Readonly<Record<string, { libelle: string; aide: string }>> = {
  forfait_phase: { libelle: 'Forfait par phase', aide: 'Un forfait est facturé à chaque phase du dossier.' },
  repartition_quote_part: {
    libelle: 'Répartition selon les quotes-parts',
    aide: 'Les honoraires sont répartis entre les héritiers selon leur quote-part.',
  },
  frais_reels: { libelle: 'Frais réels', aide: 'Les frais engagés par le cabinet sont refacturés au réel.' },
  avance_heritier: {
    libelle: 'Avance d’un héritier',
    aide: 'Un héritier avance la somme pour les autres ; elle est déduite ensuite.',
  },
  echeancier: {
    libelle: 'Échéancier',
    aide: 'Le règlement est étalé sur plusieurs échéances avant la signature.',
  },
  reglement_avoirs_notaire: {
    libelle: 'Règlement sur les avoirs, chez le notaire',
    aide: 'Les honoraires du cabinet sont réglés sur les avoirs au moment de la signature chez le notaire.',
  },
  remise: { libelle: 'Remise', aide: 'Une remise accordée par la dirigeante est appliquée au dossier.' },
};

export const LIBELLES_STATUT_LIGNE: Readonly<Record<string, string>> = {
  a_jour: 'À jour',
  echeancier: 'Échéancier en cours',
  impaye: 'Impayé',
  remise: 'Remise accordée',
};

export const LIBELLES_STATUT_ECHEANCE: Readonly<Record<string, string>> = {
  a_venir: 'À venir',
  payee: 'Payée',
  en_retard: 'En retard',
};

/** Au plus 6 échéances (réunion du 16/10, point 50) : donnée versionnée, pas une valeur fixe de l'écran. */
export const MAX_ECHEANCES = 6;

export const HERITIER_INCONNU = 'Héritier non identifié';

/** Écart C10 : un dossier sans règles ou sans date de signature garde l'écran ouvert, avec ces phrases. */
export const MESSAGE_SANS_REGLES =
  'Aucune règle de facturation n’a encore été définie pour ce dossier : cochez les règles à appliquer, puis enregistrez.';
export const MESSAGE_SANS_SIGNATURE =
  'Aucune date de signature n’est encore fixée pour ce dossier. Le calendrier de collecte apparaîtra dès qu’elle le sera.';
/** FACT-22 : la remise exige un montant et un motif (domaine, regles.ts) ; un message par champ, jamais la phrase générique. */
export const MESSAGE_REMISE_MONTANT = 'Indiquez le montant de la remise en euros, par exemple 150 ou 150,50.';
export const MESSAGE_REMISE_MOTIF = 'Indiquez le motif de la remise (3 caractères au moins).';
/** Écart C16 : aucun fournisseur de paiement n'est encore branché (l'API répond 501). */
export const MESSAGE_LIENS_NON_OUVERTS = 'Ce moyen de paiement n’est pas encore ouvert : aucun lien n’a été créé. Cabinet MAAT';
/** Écart C17 : l'écriture a réussi mais la relecture a échoué ; l'écran garde l'état précédent. */
export const MESSAGE_RELECTURE_IMPOSSIBLE = 'L’affichage n’a pas pu être actualisé : rechargez la page pour voir la nouvelle version.';
export const MESSAGE_SANS_SELECTION = 'Ouvrez la facturation depuis un dossier pour la consulter ici.';
export const MESSAGE_RAISON_REQUISE = 'Indiquez la raison du changement (3 caractères au moins) avant d’enregistrer.';
export const MESSAGE_AUCUN_CHANGEMENT = 'Aucun changement à enregistrer : cochez ou décochez une règle d’abord.';
export const MESSAGE_AUCUNE_ECHEANCE = 'Aucune échéance à régler pour cet héritier.';
export const MESSAGE_INCONNU =
  'Une erreur est survenue de notre côté. Réessayez dans un instant ; si elle persiste, contactez le Cabinet MAAT.';
export const messageEcheances = (max: number): string => `Un échéancier compte de 1 à ${max} échéances.`;

export const SUCCES = {
  regles: 'Les règles sont enregistrées : une nouvelle version a été créée.',
  echeancier: 'L’échéancier est créé.',
  facture: 'La facture est émise ; elle ne pourra plus être modifiée.',
  liens: 'Les liens de paiement sont créés.',
} as const;
